export const IDLE = 'idle'
export const LOADING = 'loading'

export type LOADING_STATE = typeof IDLE | typeof LOADING
